import { api } from "./api";

export interface CreateServiceRequestData {
  serviceDeskId?: string;
  formVersionId: string;
  title: string;
  priority: string;
  description?: string;
  data?: any;
}

export const serviceDeskApi = {
  createRequest: async (data: CreateServiceRequestData) => {
    return api.post("/api/service-desk/requests", data);
  },
  
  getMyRequests: async () => {
    return api.get("/api/service-desk/my-requests");
  },

  getServiceDesks: async (params?: any) => {
    let url = "/api/service-desk";
    if (params) {
      const searchParams = new URLSearchParams(params);
      url += `?${searchParams.toString()}`;
    }
    return api.get(url);
  },

  getRequestDetails: async (id: string) => {
    return api.get(`/api/service-desk/requests/${id}`);
  },

  updateServiceDesk: async (id: string, data: any) => {
    return api.put(`/api/service-desk/${id}`, data);
  },

  getServiceDesk: async (id: string) => {
    return api.get(`/api/service-desk/${id}`);
  },

  getServiceDeskMembers: async (id: string) => {
    return api.get(`/api/service-desk/${id}/members`);
  },

  getServiceDeskTickets: async (id: string) => {
    return api.get(`/api/service-desk/${id}/tickets`);
  },

  getFormDetails: async (id: string) => {
    return api.get(`/api/service-desk/forms/${id}`);
  },

  updateForm: async (id: string, data: any) => {
    return api.patch(`/api/service-desk/forms/${id}`, data);
  },

  retireForm: async (id: string) => {
    return api.delete(`/api/service-desk/forms/${id}`);
  },

  addAttachment: async (requestId: string, data: { filename: string, url: string, size?: number, key?: string }) => {
    return api.post(`/api/service-desk/requests/${requestId}/attachments`, data);
  },

  addComment: async (requestId: string, data: { text: string, isPrivate?: boolean }) => {
    return api.post(`/api/service-desk/requests/${requestId}/comments`, data);
  },

  updateStatus: async (requestId: string, status: string, statusNote?: string, resolutionDetails?: any) => {
    return api.patch(`/api/service-desk/requests/${requestId}/status`, { status, statusNote, resolutionDetails });
  },

  updateAssignees: async (requestId: string, userIds: string[]) => {
    return api.patch(`/api/service-desk/requests/${requestId}/assign`, { userIds });
  },

  getAttachmentDownloadUrl: async (attachmentId: string, mode: 'view' | 'download' = 'download') => {
    const modeQuery = mode === 'view' ? '?mode=view' : '';
    return api.get(`/api/service-desk/attachments/${attachmentId}/download${modeQuery}`);
  }
};
